import React, { useRef, useEffect } from "react";
import { Bold, Italic, Heading2, List, Pilcrow } from "lucide-react";

// Lightweight WYSIWYG (contentEditable). Outputs HTML with <h2>/<p>/<ul>/<b> etc.
export function RichTextEditor({ value, onChange, testId = "rte" }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const cmd = (c, v = null) => { document.execCommand(c, false, v); ref.current?.focus(); emit(); };
  const emit = () => onChange?.(ref.current?.innerHTML || "");
  const Btn = ({ icon: Icon, onClick, label }) => (
    <button type="button" onMouseDown={(e) => { e.preventDefault(); onClick(); }} title={label}
      className="rounded p-1.5 text-slate-300 hover:bg-[#1E2D4A]" data-testid={`${testId}-${label}`}>
      <Icon className="h-4 w-4" />
    </button>
  );
  return (
    <div className="rounded-lg border border-[#2D3F62] bg-[#0B1120]" data-testid={testId}>
      <div className="flex gap-1 border-b border-[#2D3F62] px-2 py-1.5">
        <Btn icon={Heading2} label="heading" onClick={() => cmd("formatBlock", "<h2>")} />
        <Btn icon={Pilcrow} label="paragraph" onClick={() => cmd("formatBlock", "<p>")} />
        <Btn icon={Bold} label="bold" onClick={() => cmd("bold")} />
        <Btn icon={Italic} label="italic" onClick={() => cmd("italic")} />
        <Btn icon={List} label="list" onClick={() => cmd("insertUnorderedList")} />
      </div>
      <div ref={ref} contentEditable suppressContentEditableWarning onInput={emit}
        className="ns-rte max-h-[420px] min-h-[220px] overflow-auto px-3 py-2 text-sm text-slate-100 focus:outline-none"
        data-testid={`${testId}-area`} />
    </div>
  );
}
